/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material/styles';

export const facetNavigationAccordionSX: SxProps = {
	boxShadow: 25,
	borderBottom: '1px solid #545454',
	'&:first-of-type': {
        borderTop: '1px solid #545454', 
    },
};
